export default "<div class=\"form-modal\">\r\n\t<app-form #childForm [formData]=\"modalFormData\" [modeType]=\"modeType\" ></app-form>\r\n</div>"